import { getRouteApi, useRouter } from "@tanstack/react-router";

import type { BuildListParamsInput } from "../build-list-params";
import { useFilterUrlKeys } from "../filter-url-keys";

/**
 * The current route's raw list search — `filters` (operator brackets
 * included), free-text `search` and the canonical `sort` string — under the
 * nearest `FilterUrlKeysProvider`'s keys (the defaults without one).
 *
 * Pass `override` to read an explicit search object instead of the current
 * route's (a prefetch for the destination route).
 */
export function useRouteListSearch(
  override?: Record<string, unknown>,
): NonNullable<BuildListParamsInput["search"]> {
  const router = useRouter();
  const routeId = router.state.matches.at(-1)?.routeId;
  const routeApi = getRouteApi(routeId as never);
  const routeSearch = routeApi.useSearch() as Record<string, unknown>;
  const search = override ?? routeSearch;
  const keys = useFilterUrlKeys();

  return {
    filters: search[keys.filters] as Record<string, unknown> | undefined,
    search: search[keys.search] as string | undefined,
    sort: search[keys.sort] as string | undefined,
  };
}
